import axiosIns from '@/libs/axios'

const ROOT_URL = '/Admin/defines/task_priorities'
export default {
  namespaced: true,
  state: {
    loading: false,
    dataList: [],
    dataCounts: 0,
    dataItem: {
      id: null,
      id_licenses: null,
      title: null,
      id_users: null,
    },
    dataSave: {
      message: null,
      status: null,
      id: null,
    },
  },
  getters: {
    loading(state) {
      return state.loading
    },
    dataList(state) {
      return state.dataList
    },
    dataCounts(state) {
      return state.dataCounts
    },
    dataItem(state) {
      return state.dataItem
    },
    dataSaveStatus(state) {
      return state.dataSave
    },
  },
  mutations: {
    SET_DATA_LIST(state, data) {
      state.dataList = data
    },
    SET_DATA_ITEM(state, data) {
      state.dataItem = data
    },
    SET_DATA_COUNTS(state, data) {
      state.dataCounts = data
    },
    SET_DATA_SAVE(state, data) {
      state.dataSave = data
    },
    RESET_DATA_ITEM(state) {
      state.dataItem = {
        id: null,
        id_licenses: null,
        title: null,
        id_users: null,
      }
    },
    SET_LOADING(state, data) {
      state.loading = data
    },
  },
  actions: {
    getDataList({ commit }, params) {
      commit('RESET_DATA_ITEM')
      commit('SET_LOADING', true)
      axiosIns
        .post(ROOT_URL, params)
        .then(response => {
          commit('SET_DATA_LIST', response.data.data)
          commit('SET_DATA_COUNTS', response.data.count)
          commit('SET_LOADING', false)
        })
        .catch(error => console.error(error))
    },
    async getDataItem({ commit }, id) {
      if (Number(id)) {
        commit('SET_LOADING', true)
        commit('RESET_DATA_ITEM')
        const data = {
          where: {
            'task_priorities.id': id,
          },
          array: false,
        }
        return axiosIns
          .post(ROOT_URL, data)
          .then(response => {
            commit('SET_DATA_ITEM', response.data.data)
            commit('SET_LOADING', false)
            return response.data.data
          })
          .catch(error => console.error(error))
      }
      return false
    },
    saveData({ commit }, postData) {
      const data = JSON.stringify(postData)
      axiosIns
        .post(`${ROOT_URL}/saveData`, data)
        .then(response => {
          commit('SET_DATA_SAVE', response.data)
        })
        .catch(error => console.error(error))
    },
    removeData({ commit }, id) {
      return axiosIns
        .post(`${ROOT_URL}/deleteData`, { id })
        .then(response => {
          commit('SET_DATA_SAVE', response.data)
          return response.data.status
        })
        .catch(error => console.error(error))
    },
  },
}
